module.exports = __webpack_public_path__ + "img/3.70f19ea0.png";